module.exports = __webpack_public_path__ + "img/me.74a8680a.png";